module.exports = __webpack_public_path__ + "img/1480370918.0ecc7a98.jpg";